<template>
  <RevDrawer
    :close-button-label="i18n(translations.close)"
    has-padding
    :name="MODAL_NAMES.TELCO_CALCULATOR"
    :title="i18n(translations.title)"
  >
    <template #body>
      <h2 class="heading-1">
        {{ i18n(translations.section1Title) }}
      </h2>
      <div class="body-1 pt-24">
        {{ i18n(translations.section1Description) }}
      </div>
      <h2 class="body-1-bold pt-32">
        {{ i18n(translations.section2Title) }}
      </h2>
      <slot name="configurator" />
      <div class="bg-static-default-low rounded-lg mt-24 p-16">
        <div class="body-1-bold">
          {{
            savings > 0
              ? i18n(translations.savingsTitle)
              : i18n(translations.summaryTitle)
          }}
        </div>
        <div class="body-1 flex justify-between pt-16">
          <div>{{ i18n(translations.savingsTelcoTotalCost) }}</div>
          <div class="max-w-[50%] whitespace-normal break-words">
            {{ i18n.price(priceTelco) }}
          </div>
        </div>
        <div class="flex justify-between pt-16">
          <div class="flex flex-col">
            <div class="body-1">
              {{ i18n(translations.savingsBMTotalCost) }}
            </div>
            <div class="text-static-default-low caption">
              {{ i18n(translations.savingsBMPlan) }}
            </div>
          </div>
          <div>{{ i18n.price(priceBM) }}</div>
        </div>
        <RevDivider v-if="savings > 0" class="my-16" />
        <div v-if="savings > 0" class="flex items-center justify-between">
          <RevTag
            class="shrink-0"
            :label="i18n(translations.savings)"
            variant="success"
          />
          <div
            class="text-static-success-hi body-1-bold ml-8 max-w-[50%] whitespace-normal break-words"
          >
            {{ i18n.price(savings) }}
          </div>
        </div>
      </div>
      <RevAccordionItem>
        <template #title>
          <div class="body-2-link underline">
            {{ i18n(translations.detailsTitle) }}
          </div>
        </template>

        <template #body>
          <div class="text-action-default-low body-2">
            {{ i18n(translations.detailsDescription) }}
          </div>
        </template>
      </RevAccordionItem>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevDivider } from '@ds/components/Divider'
import { RevDrawer } from '@ds/components/Drawer'
import { RevTag } from '@ds/components/Tag'

import { MODAL_NAMES } from '~/scopes/product/constants'

import translations from './TelcoCalculatorModal.translations'

defineProps<{
  priceTelco: number
  priceBM: number
  savings: number
}>()

const i18n = useI18n()
</script>
